import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMcIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 14,
	viewBox: "0 0 17 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.001 0C10.5858 0 9.32482 1.88441 8.50106 4.82933C7.67518 1.88441 6.41419 0 5.00112 0C2.51505 0 0.5 6.268 0.5 14H2.50026C2.50026 6.81726 3.61974 0.999245 5.00112 0.999245C6.38251 0.999245 7.49987 6.37362 7.49987 13.0008H9.50013C9.50013 6.37362 10.6196 0.999245 12.001 0.999245C13.3824 0.999245 14.4997 6.81938 14.4997 14H16.5C16.5 6.268 14.485 0 12.001 0Z",
		fill: "#FFBC0D"
	})
});
export default SvgMcIcon;
